export const HotkeyGroup = {
  Navigation: 'Navigation',
  General: 'General',
  Admin: 'Admin',
  Drawer: 'Drawer',
  SearchOverlay: 'Global Search Overlay',
  DataExplorer: 'Data Explorer',
  DashboardSavedView: 'Dashboard/Saved View',
  Library: 'Library',
  InterfaceClassification: 'Interface Classification',
  FormControl: 'Form' // generic form controls - could possibly do with clearer targeting
};
